<template>
    <rkm-modal
        :loading="loading"
        large
        ref="RkmModal"
        title="Confirmação de óbito"
    >

    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-col cols="12">
            Ao registrar o óbito, o paciente deixará de ser considerado o responsável familiar,
            sendo necessário indicar outro membro da família para assumir essa responsabilidade.
        </rkm-col>

        <rkm-col cols="12" class="mt-3">
            <rkm-form-select
                :options="data.form.responsaveis.length == 0 ? data.form.residentes : data.form.responsaveis"
                label="Novo responsável familiar"
                show-default-option
                text-field="nome"
                v-model="data.model.cidadao.responsavelCidadaoId"
                default-option-text="Selecione"
                value-field="id"
                :validations="validations.responsavelFamiliar"
            />
        </rkm-col>
    </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="handleCancel()">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="handleRegister()"
                color="primary"
            >
                Registrar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

export default {
    computed: {
        validations() {

            return {
                responsavelFamiliar: { required: true },
            }
        },
    },
    data: () => ({
        loading: false,
        model: {},
    }),
    methods: {
        async validate() {

return this.$refs.RkmModal.validate()
},
        open() {
            this.$refs.RkmModal.show()
        },
        handleCancel() {

            this.data.model.informacao.saidaCidadaoId = null

            this.$refs.RkmModal.hide()
        },
        handleRegister() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                this.data.model.cidadao.responsavel = false

                if (this.data.form.responsaveis.length == 0) {

                    const responsavel = this.data.form.residentes.find(responsavel =>
                        responsavel.id == this.data.model.cidadao.responsavelCidadaoId)

                    if (responsavel.ocupacaoId) {

                        this.data.model.cidadao.ocupacao = {
                            id: responsavel.ocupacaoId,
                            codigo: responsavel.ocupacaoCodigo,
                            nome: responsavel.ocupacaoNome,
                        };
                    }

                    this.data.form.responsaveis.push(responsavel)
                }

                this.$refs.RkmModal.hide()
            })
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>